import React, { useContext } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import useCWPContext from '../context/useCWPContext';

export default function RejectAllModal() {
  const { rejectAllModal, handleCloseRejectAllModal } = useContext(useCWPContext);
  return (
    <Dialog open={rejectAllModal} onClose={handleCloseRejectAllModal} maxWidth='sm' fullWidth>
      <DialogTitle>Reject All </DialogTitle>
      <DialogContent dividers />
      <DialogActions />
    </Dialog>
  );
}
